module.exports = __webpack_public_path__ + "img/register-v2.f1fa9a2e.svg";